/* eslint-disable max-len */
import {pathWithParams, apiVersion, DEFAULT_TIMEOUT, setErrorApi} from '@/utils/constants';
import {handleErrorCustom} from '@/utils/errorHandling';
import {sucessCustom} from '@/utils/successHandling';
import {useAxios} from '@sttedra_ui/framework';

// #region Globals
const {base} = useAxios();
const servicio = 'Permiso';
// #endregion

async function postFilterPermiso(_datafilter) {
  const url = `${pathWithParams()}${servicio}/Filter?${apiVersion}`;
  try {
    const {data: response} = await base.post(url, _datafilter, {timeout: DEFAULT_TIMEOUT});
    return response.objetoSalida;
  } catch (error) {
    if (error.code === 'ERR_NETWORK') setErrorApi();
    handleErrorCustom(error);
  }
}

async function getPermisoId(_id) {
  const url = `${pathWithParams()}${servicio}/${_id}?${apiVersion}`;
  try {
    const {data: response} = await base.get(url, {timeout: DEFAULT_TIMEOUT});
    return response.objetoSalida;
  } catch (error) {
    if (error.code === 'ERR_NETWORK') setErrorApi();
    handleErrorCustom(error);
  }
}

async function postAddPermiso(_data) {
  const url = `${pathWithParams()}${servicio}?${apiVersion}`;
  try {
    const {data: response} = await base.post(url, _data, {timeout: DEFAULT_TIMEOUT});
    sucessCustom(response.message);
    return response.success;
  } catch (error) {
    if (error.code === 'ERR_NETWORK') setErrorApi();
    handleErrorCustom(error);
  }
}

async function getListPermisosByUnidadId(_registro) {
  let urlRegistro = '';
  if (_registro) {
    urlRegistro = `registro=${_registro}&`;
  }

  const url = `${pathWithParams()}${servicio}/ListPermisosByUnidadId?${urlRegistro}${apiVersion}`;
  try {
    const {data: response} = await base.get(url, {timeout: DEFAULT_TIMEOUT});
    return response.objetoSalida;
  } catch (error) {
    if (error.code === 'ERR_NETWORK') setErrorApi();
    handleErrorCustom(error);
  }
}

async function getListResponsablesByUnidadId() {
  const url = `${pathWithParams()}${servicio}/ListResponsablesByUnidadId?${apiVersion}`;
  try {
    const {data: response} = await base.get(url, {timeout: DEFAULT_TIMEOUT});
    return response.objetoSalida;
  } catch (error) {
    if (error.code === 'ERR_NETWORK') setErrorApi();
    handleErrorCustom(error);
  }
}

async function getListPermisosByUsuarioId() {
  const url = `${pathWithParams()}${servicio}/ListPermisosByUsuarioId?${apiVersion}`;
  try {
    const {data: response} = await base.get(url, {timeout: DEFAULT_TIMEOUT});
    return response.objetoSalida;
  } catch (error) {
    if (error.code === 'ERR_NETWORK') setErrorApi();
    handleErrorCustom(error);
  }
}

async function getTipoPermisoListUsuario(_tipoPermisoId) {
  const url = `${pathWithParams()}${servicio}/${_tipoPermisoId}/ListUsuario?${apiVersion}`;
  try {
    const {data: response} = await base.get(url, {timeout: DEFAULT_TIMEOUT});
    return response.objetoSalida;
  } catch (error) {
    if (error.code === 'ERR_NETWORK') setErrorApi();
    handleErrorCustom(error);
  }
}

export {
  postFilterPermiso,
  getPermisoId,
  postAddPermiso,
  getListPermisosByUnidadId,
  getListResponsablesByUnidadId,
  getListPermisosByUsuarioId,
  getTipoPermisoListUsuario,
};
